import { render } from "./HelpButtonContent.vue?vue&type=template&id=79892a85&lang=pug"
import script from "./HelpButtonContent.vue?vue&type=script&lang=js"
export * from "./HelpButtonContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__